const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:3000';

export function resolveUrl(path: string) {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return new URL(path, API_BASE_URL).toString();
}

export async function readResponseBody(response: Response) {
  const contentType = response.headers?.get?.('content-type');
  const contentLength = response.headers?.get?.('content-length');

  if (contentLength === '0') {
    return null;
  }

  if (typeof response.text === 'function') {
    try {
      const text = await response.text();

      if (!text) {
        return null;
      }

      if (contentType?.includes('application/json') || !contentType) {
        try {
          return JSON.parse(text);
        } catch (error) {
          return { message: text };
        }
      }

      return { message: text };
    } catch (error) {
      // Fall back to response.json() for mocked responses that only implement json().
    }
  }

  if (typeof response.json === 'function') {
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  return null;
}

export function extractErrorMessage(payload: unknown, fallbackMessage: string) {
  if (payload && typeof payload === 'object') {
    const record = payload as Record<string, unknown>;
    const candidate =
      record.message ??
      record.error ??
      record.detail ??
      (record.errors && Array.isArray(record.errors)
        ? record.errors.join(', ')
        : undefined);

    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate;
    }
  }

  return fallbackMessage;
}
